import { useMutation } from "@tanstack/react-query";

import {
  ILiberarRemessasLotePayload,
  ILiberarRemessasLoteResponse,
  ILiberarRemessasLoteValidacaoResponse,
} from "@/hooks/liberar-remessa/index.d";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleRecepcaoLiberarRemessasEmLote } from "@/domain/use-cases/liberar-remessa";
import { notifyError } from "@/utils/notify-messages";

export function useRecepcaoLiberarRemessasLote() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    ILiberarRemessasLoteResponse | ILiberarRemessasLoteValidacaoResponse,
    Error,
    ILiberarRemessasLotePayload
  >({
    mutationFn: async (payload) => {
      return (await handleRecepcaoLiberarRemessasEmLote(token!, payload)) as
        | ILiberarRemessasLoteResponse
        | ILiberarRemessasLoteValidacaoResponse;
    },
    onError: () => {
      notifyError("Houve um problema ao tentar liberar as remessas em lote!");
    },
  });

  return {
    recepcaoLiberarRemessasEmLote: mutation.mutate,
    recepcaoLiberarRemessasEmLoteAsync: mutation.mutateAsync,
    isLoadingRecepcaoLiberarRemessasEmLote: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
